import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TwoKeySpinner from './TwoKeySpinner';
import TreeLoaderAnimation from '../../icons/tree-loader.gif';

const StyledLoader = styled.div`
  &.absolute {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10px;
    background: rgba(255, 255, 255, .75);
  }
  
  &.global {
    position: absolute;
    top: calc(50vh - 50px);
    left: calc(50vw - 50px);
  }
`;

const LoaderTypes = {
  basic: <TwoKeySpinner />,
  secondary: <img src={TreeLoaderAnimation} alt={TreeLoaderAnimation} />,
};

const Loader = ({ className = '', type = 'basic' }) => (
  <StyledLoader className={className}>
    {LoaderTypes[type] || LoaderTypes.basic}
  </StyledLoader>
);

Loader.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['basic', 'secondary']),
};

export default Loader;
